























import { defineComponent, ref } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import PageDetailTable from '@/components/organisms/questionnaire/PageDetailTable.vue'
import { useUser } from '@/composable/common/useUser'
import { useQuestionnaireLoading } from '@/composable/questionnaire/useQuestionnaireLoading'

export default defineComponent({
  name: 'CreateQuestionnairePage',
  components: { Layout, PageDetailTable },
  setup(props, context) {
    const { user } = useUser(context)

    const snackbar = ref({
      snackbar: false,
      message: '',
    })

    const { isLoading } = useQuestionnaireLoading(context)

    const save = async (body: {
      sentence: string
      htmlContent: string
      image: string
    }) => {
      try {
        await context.root.$store.dispatch(
          'questionnaire/createQuestionnairePage',
          {
            ...body,
            questionnaireId: parseInt(context.root.$route.params.id),
          },
        )
        const path = context.root.$route.path.replace('create-page', 'detail')
        context.root.$router.push(path)
      } catch (e) {
        snackbar.value.snackbar = true
        snackbar.value.message = 'エラーが発生しました。'
      }
    }

    const cancel = () => {
      const path = context.root.$route.path.replace('create-page', 'detail')
      context.root.$router.push(path)
    }

    return { user, snackbar, isLoading, save, cancel }
  },
})
